import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { tID } from '../../utils'

export interface DraftPageIconProps {
  size?: number | string
  color?: string
}

export const DraftPageIcon: FunctionComponent<DraftPageIconProps> = ({ size = 24, color }) => {
  const { colors } = useTheme()
  return (
    <Svg testID={tID('DraftPageIcon')} width={size} height={size} viewBox='0 0 24 24' fill='none'>
      <Path
        d='M10.833 1.66699H4.99967C4.55765 1.66699 4.13372 1.84259 3.82116 2.15515C3.5086 2.46771 3.33301 2.89163 3.33301 3.33366V16.667C3.33301 17.109 3.5086 17.5329 3.82116 17.8455C4.13372 18.1581 4.55765 18.3337 4.99967 18.3337H14.9997C15.4417 18.3337 15.8656 18.1581 16.1782 17.8455C16.4907 17.5329 16.6663 17.109 16.6663 16.667V7.50033L10.833 1.66699Z'
        stroke={color ?? colors.iconDefault}
      />
      <Path d='M10.833 1.66699V7.50033H16.6663' stroke={color ?? colors.iconDefault} />
    </Svg>
  )
}
